export default __webpack_public_path__ + "static/media/logo4.5f09e6c7.png";